import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, createElementVNode as _createElementVNode, withCtx as _withCtx, isRef as _isRef, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "vab-tabs"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 1
};
import { useTabsStore } from '@/store/modules/tabs';
import { useRoutesStore } from '@/store/modules/routes';
import { useSettingsStore } from '@/store/modules/settings';
import { handleActivePath, handleTabs } from '@/utils/routes';
import { translate } from '@/i18n';
import { useRouterHelperStore } from '~/src/store/modules/routerHelper';

import { inject, ref, watch, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useFullscreen, useMouse } from '@vueuse/core';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    layout: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const $pub = inject('$pub');
    const route = useRoute();
    const router = useRouter();
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const routesStore = useRoutesStore();
    const {
      getRoutes: routes
    } = storeToRefs(routesStore);
    const tabsStore = useTabsStore();
    const {
      getVisitedRoutes: visitedRoutes
    } = storeToRefs(tabsStore);
    const {
      addVisitedRoute,
      delVisitedRoute,
      delOthersVisitedRoutes,
      delLeftVisitedRoutes,
      delRightVisitedRoutes,
      delAllVisitedRoutes
    } = tabsStore;
    const tabActive = ref('');
    const active = ref(false);
    const hoverRoute = ref();
    const visible = ref(false);
    const top = ref(0);
    const left = ref(0);
    const {
      isFullscreen
    } = useFullscreen();
    const isActive = path => path === handleActivePath(route, true);
    const isNoCLosable = tag => tag.meta.noClosable;
    const handleTabClick = tab => {
      const index = parseInt(tab.index) + 1;
      if (!isActive(tab.name)) router.push(visitedRoutes.value[index]);
    };
    const handleTabClickFirst = tab => {
      if (!isActive(tab.name)) router.push(visitedRoutes.value[tab.index]);
    };
    const handleVisibleChange = val => {
      active.value = val;
    };
    const initNoCLosableTabs = routes => {
      routes.forEach(_route => {
        if (_route.meta.noClosable) addTabs(_route);
        if (_route.children) initNoCLosableTabs(_route.children);
      });
    };
    /**
     * 添加标签页
     * @param tag route
     * @returns {Promise<void>}
     */
    const addTabs = async tag => {
      const tab = handleTabs(tag);
      if (tab) {
        await addVisitedRoute(tab);
        tabActive.value = tab.path;
      }
    };
    /**
     * 根据原生路径删除标签中的标签
     * @param rawPath 原生路径
     * @returns {Promise<void>}
     */
    const handleTabRemove = async rawPath => {
      console.log('rawPath', rawPath);
      const closingRoute = visitedRoutes.value.find(r => r.path === rawPath);
      const routerHelper = useRouterHelperStore();
      let shouldJump = false;
      if (closingRoute) {
        if (closingRoute.meta?.editRouteName) {
          const listName = closingRoute.name;
          const editStatus = routerHelper.getEditStatus(listName);
          if (editStatus.isEditing) {
            if (route.name === editStatus.route.name) {
              shouldJump = true;
            }
            routerHelper.clearEditStatus(listName);
          }
        }
        if (closingRoute.meta?.listRouteName) {
          const listName = closingRoute.meta.listRouteName;
          routerHelper.clearEditStatus(listName);
        }
      }
      if (shouldJump || isActive(rawPath)) {
        // 跳转时排除当前路径和即将关闭的Tab
        const currentPath = handleActivePath(route, true);
        const latestView = visitedRoutes.value.filter(_ => _.path !== currentPath && _.path !== rawPath).slice(-1)[0];
        if (latestView) {
          await router.push(latestView);
        } else {
          await router.push('/');
        }
      }
      await delVisitedRoute(rawPath);
    };
    // const handleTabRemove: any = async (rawPath: string) => {
    //   console.log('rawPath',rawPath)
    //   if (isActive(rawPath)) await toLastTab()
    //   await delVisitedRoute(rawPath)
    // }
    const handleCommand = command => {
      switch (command) {
        case 'refreshThisTab':
          refreshThisTab();
          break;
        case 'closeOthersTabs':
          closeOthersTabs();
          break;
        case 'closeLeftTabs':
          closeLeftTabs();
          break;
        case 'closeRightTabs':
          closeRightTabs();
          break;
        case 'closeAllTabs':
          closeAllTabs();
          break;
      }
    };
    /**
     * 刷新当前标签页
     * @returns {Promise<void>}
     */
    const refreshThisTab = () => {
      $pub('reload-router-view');
    };
    /**
     * 删除其他标签页
     * @returns {Promise<void>}
     */
    const closeOthersTabs = async () => {
      if (hoverRoute.value) {
        await router.push(hoverRoute.value);
        await delOthersVisitedRoutes(hoverRoute.value.path);
      } else await delOthersVisitedRoutes(handleActivePath(route, true));
      await closeMenu();
    };
    /**
     * 删除左侧标签页
     * @returns {Promise<void>}
     */
    const closeLeftTabs = async () => {
      if (hoverRoute.value) {
        await router.push(hoverRoute.value);
        await delLeftVisitedRoutes(hoverRoute.value.path);
      } else await delLeftVisitedRoutes(handleActivePath(route, true));
      await closeMenu();
    };
    /**
     * 删除右侧标签页
     * @returns {Promise<void>}
     */
    const closeRightTabs = async () => {
      if (hoverRoute.value) {
        await router.push(hoverRoute.value);
        await delRightVisitedRoutes(hoverRoute.value.path);
      } else await delRightVisitedRoutes(handleActivePath(route, true));
      await closeMenu();
    };
    /**
     * 删除所有标签页
     * @returns {Promise<void>}
     */
    const closeAllTabs = async () => {
      await delAllVisitedRoutes();
      await toLastTab();
      await closeMenu();
    };
    /**
     * 跳转最后一个标签页
     */
    const toLastTab = async () => {
      const latestView = visitedRoutes.value.filter(_ => _.path !== handleActivePath(route, true)).slice(-1)[0];
      if (latestView) await router.push(latestView);else await router.push('/');
    };
    const {
      x,
      y
    } = useMouse();
    const openMenu = () => {
      left.value = x.value;
      top.value = y.value;
      visible.value = true;
    };
    const closeMenu = () => {
      visible.value = false;
      hoverRoute.value = null;
    };
    initNoCLosableTabs(routes.value);
    watch(() => route.fullPath, () => {
      addTabs(route);
      if (route.meta.activeMenu) {
        tabActive.value = route.meta.activeMenu;
      }
    }, {
      immediate: true
    });
    watchEffect(() => {
      if (visible.value) document.body.addEventListener('click', closeMenu);else document.body.removeEventListener('click', closeMenu);
    });
    return (_ctx, _cache) => {
      const _component_vab_fold = _resolveComponent("vab-fold");
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [__props.layout === 'common' ? (_openBlock(), _createBlock(_component_vab_fold, {
        key: 0
      })) : _createCommentVNode("", true), _unref(visitedRoutes).length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["el-tabs__item vab-tabs-fixed-first", {
          'is-active': isActive(_unref(visitedRoutes)[0].path)
        }]),
        onClick: _cache[0] || (_cache[0] = $event => handleTabClickFirst({
          name: _unref(visitedRoutes)[0].path,
          index: 0
        })),
        onContextmenu: _cache[1] || (_cache[1] = _withModifiers(e => {
          hoverRoute.value = _unref(visitedRoutes)[0];
          openMenu();
        }, ["prevent"]))
      }, [_unref(theme).showTabsIcon ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(visitedRoutes)[0].meta?.icon ? (_openBlock(), _createBlock(_component_vab_icon, {
        key: 0,
        icon: _unref(visitedRoutes)[0].meta.icon,
        "is-custom-svg": _unref(visitedRoutes)[0].meta.isCustomSvg
      }, null, 8, ["icon", "is-custom-svg"])) : (_openBlock(), _createBlock(_component_vab_icon, {
        key: 1,
        icon: _unref(visitedRoutes)[0].parentIcon
      }, null, 8, ["icon"]))], 64)) : _createCommentVNode("", true), _unref(visitedRoutes)[0].meta?.title ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(translate)(_unref(visitedRoutes)[0].meta.title)), 1)) : _createCommentVNode("", true)], 34)) : _createCommentVNode("", true), _createVNode(_component_el_tabs, {
        modelValue: _unref(tabActive),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(tabActive) ? tabActive.value = $event : null),
        class: _normalizeClass(["vab-tabs-content", {
          ['vab-tabs-content-' + _unref(theme).tabsBarStyle]: true
        }]),
        type: "card",
        onTabClick: handleTabClick,
        onTabRemove: handleTabRemove
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visitedRoutes), (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.path
          }, [index !== 0 ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 0,
            closable: !isNoCLosable(item),
            name: item.path
          }, {
            label: _withCtx(() => [_createElementVNode("span", {
              style: {
                "display": "inline-block"
              },
              onContextmenu: _withModifiers(openMenu, ["prevent"])
            }, [_unref(theme).showTabsIcon ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [item.meta && item.meta.icon ? (_openBlock(), _createBlock(_component_vab_icon, {
              key: 0,
              icon: item.meta.icon,
              "is-custom-svg": item.meta.isCustomSvg
            }, null, 8, ["icon", "is-custom-svg"])) : (_openBlock(), _createBlock(_component_vab_icon, {
              key: 1,
              icon: item.parentIcon
            }, null, 8, ["icon"]))], 64)) : _createCommentVNode("", true), item.meta && item.meta.title ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(translate)(item.meta.title)), 1)) : _createCommentVNode("", true)], 32)]),
            _: 2
          }, 1032, ["closable", "name"])) : _createCommentVNode("", true)], 64);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "class"]), _createVNode(_component_el_dropdown, {
        placement: "bottom-end",
        "popper-class": "vab-tabs-more-dropdown",
        onCommand: handleCommand,
        onVisibleChange: handleVisibleChange
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "tabs-more"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "refreshThisTab"
          }, {
            default: _withCtx(() => [_createVNode(_component_vab_icon, {
              icon: "refresh-line"
            }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('刷新')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "closeOthersTabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_vab_icon, {
              icon: "close-line"
            }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('关闭其他')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "closeLeftTabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_vab_icon, {
              icon: "arrow-left-line"
            }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('关闭左侧')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "closeRightTabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_vab_icon, {
              icon: "arrow-right-line"
            }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('关闭右侧')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "closeAllTabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_vab_icon, {
              icon: "close-line"
            }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('关闭全部')), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", {
          class: _normalizeClass(["vab-tabs-more", {
            'vab-tabs-more-active': _unref(active)
          }])
        }, [...(_cache[3] || (_cache[3] = [_createElementVNode("span", {
          class: "vab-tabs-more-icon"
        }, [_createElementVNode("i", {
          class: "box box-t"
        }), _createElementVNode("i", {
          class: "box box-b"
        })], -1)]))], 2)]),
        _: 1
      }), _unref(visible) ? (_openBlock(), _createElementBlock("ul", {
        key: 2,
        class: "contextmenu el-dropdown-menu",
        style: _normalizeStyle({
          left: _unref(left) + 'px',
          top: _unref(top) + 'px'
        })
      }, [_createElementVNode("li", {
        class: "el-dropdown-menu__item",
        onClick: refreshThisTab
      }, [_createVNode(_component_vab_icon, {
        icon: "refresh-line"
      }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('刷新')), 1)]), _createElementVNode("li", {
        class: _normalizeClass(["el-dropdown-menu__item", {
          'is-disabled': _unref(visitedRoutes).length === 1
        }]),
        onClick: closeOthersTabs
      }, [_createVNode(_component_vab_icon, {
        icon: "close-line"
      }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('关闭其他')), 1)], 2), _createElementVNode("li", {
        class: _normalizeClass(["el-dropdown-menu__item", {
          'is-disabled': !_unref(visitedRoutes).indexOf(_unref(hoverRoute))
        }]),
        onClick: closeLeftTabs
      }, [_createVNode(_component_vab_icon, {
        icon: "arrow-left-line"
      }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('关闭左侧')), 1)], 2), _createElementVNode("li", {
        class: _normalizeClass(["el-dropdown-menu__item", {
          'is-disabled': _unref(visitedRoutes).indexOf(_unref(hoverRoute)) === _unref(visitedRoutes).length - 1
        }]),
        onClick: closeRightTabs
      }, [_createVNode(_component_vab_icon, {
        icon: "arrow-right-line"
      }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('关闭右侧')), 1)], 2), _createElementVNode("li", {
        class: "el-dropdown-menu__item",
        onClick: closeAllTabs
      }, [_createVNode(_component_vab_icon, {
        icon: "close-line"
      }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('关闭全部')), 1)])], 4)) : _createCommentVNode("", true)], 512)), [[_vShow, !_unref(isFullscreen)]]);
    };
  }
});